"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichAIWidgetsContainer = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const react_redux_1 = require("react-redux");
const catalog_1 = require("./client/catalog");
const get_catalog_download_url_hook_1 = __importDefault(require("./client/catalog/get-catalog-download-url.hook"));
const hooks_1 = require("./client/catalog/hooks");
const hooks_2 = require("./client/hooks");
const hooks_3 = require("./client/product/hooks");
const components_1 = require("./components");
const context_1 = require("./context");
const enrich_ai_settings_widget_1 = require("./enrich-ai-settings-widget");
const enrich_ai_widgets_page_title_buttons_1 = require("./enrich-ai-widgets-page-title-buttons");
const enrich_ai_widgets_utils_1 = require("./enrich-ai-widgets.utils");
const enrich_ai_styles_1 = require("./enrich-ai.styles");
const hooks_4 = require("./hooks");
const upload_file_options_1 = require("./models/upload-file-options");
const preview_products_loader_1 = require("./preview-products-loader");
const preview_products_widget_1 = require("./preview-products-widget");
const strategy_preview_1 = require("./strategy-preview");
const upload_data_dialog_1 = require("./upload-data-dialog");
const feature_flags_1 = require("../feature-flags");
const hooks_5 = require("../hooks");
const localization_1 = require("../localization");
const store_1 = require("../store");
const lockout_1 = require("./utils/lockout");
// eslint-disable-next-line complexity
const EnrichAIWidgetsContainer = () => {
    var _a;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { featureFlagsService } = (0, hooks_5.useFeatureFlagsService)();
    const isMeasuresEnabled = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.Measures);
    const { clearStore } = (0, hooks_2.useClearStore)();
    const { refetchProductTree, refetchProductList } = (0, hooks_2.useRefetchQueries)();
    const selectedProjectId = (0, store_1.useSelectedProjectId)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedTreeNodeId = (0, store_1.useSelectedTreeNodeId)();
    const onSelectCatalog = (0, react_1.useCallback)((catalog) => dispatch((0, store_1.enrichAISetSelectedCatalog)(catalog)), [dispatch]);
    const onCatalogTagsUpdate = (0, react_1.useCallback)((id, tags) => dispatch((0, store_1.enrichAISetCatalogTags)(id, tags)), [dispatch]);
    const onSelectProject = (0, react_1.useCallback)((project) => dispatch((0, store_1.enrichAISetSelectedProject)(project)), [dispatch]);
    // need to prevent blinking screen between creating ticket sequence for catalog and getting catalog state
    const [isInitialCatalogStatusLoading, setIsInitialCatalogStatusLoading] = (0, react_1.useState)(false);
    const [isUploadDataDialogOpen, setIsUploadDataDialogOpen] = (0, react_1.useState)(false);
    const [isFileUploading, setIsFileUploading] = (0, react_1.useState)(false);
    // Manual blocking for file operations (upload/replace/merge)
    const [isFileOperationBlocking, setIsFileOperationBlocking] = (0, react_1.useState)(false);
    const hasObservedCatalogActivity = (0, react_1.useRef)(false);
    const [fileUploadError, setFileUploadError] = (0, react_1.useState)(null);
    (0, hooks_4.useApplyQueryParamsForWorkspace)();
    const { updateAggregationStatus } = (0, context_1.useProductTreeNodeReaggregationStatus)();
    const { isUploadInProgress, catalogProgress, catalogProgressState, catalogActivityError, } = (0, context_1.useCatalogActivityProgressContext)();
    const { getCatalogById, inFlightCatalogRequest, catalog, error: catalogLoadError, } = (0, catalog_1.useCatalogProgress)({ catalogId: selectedCatalogId });
    const { getCatalogDownloadUrl, loading } = (0, get_catalog_download_url_hook_1.default)({ catalogId: selectedCatalogId });
    const { createNewCatalog } = (0, hooks_1.useCreateNewCatalog)();
    // TODO: fix types
    const { replaceCatalog } = (0, hooks_1.useReplaceCatalog)({ catalog: catalog });
    const { updateCatalog } = (0, hooks_1.useUpdateCatalog)({ catalog: catalog });
    const { addBulkAssertions, loading: isEnrichedDataUpdating, error: updateEnrichedDataError, } = (0, hooks_3.usePromisedBulkAssertions)({ catalogId: selectedCatalogId });
    const onSelectStrategyNodePath = (0, react_1.useCallback)((path) => dispatch((0, store_1.enrichAISetSelectedTreeNodePath)(path)), [dispatch]);
    const loadCatalog = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!selectedCatalogId || inFlightCatalogRequest.current) {
            return;
        }
        setIsInitialCatalogStatusLoading(true);
        try {
            const catalog = yield getCatalogById();
            const { id, tags } = catalog !== null && catalog !== void 0 ? catalog : {};
            if (!id) {
                throw new Error('Catalog not found.');
            }
            const catalogTags = (_b = (_a = tags === null || tags === void 0 ? void 0 : tags.edges) === null || _a === void 0 ? void 0 : _a.map(({ node }) => node)) !== null && _b !== void 0 ? _b : [];
            onCatalogTagsUpdate(id, catalogTags);
        }
        catch (error) {
            if (error instanceof Error) {
                setFileUploadError(error);
            }
            else {
                setFileUploadError(new Error(t({ key: 'GENERAL_ERROR_MESSAGE' })));
            }
        }
        finally {
            setIsInitialCatalogStatusLoading(false);
        }
    }), [selectedCatalogId, inFlightCatalogRequest, getCatalogById, onCatalogTagsUpdate, t]);
    (0, react_1.useEffect)(() => {
        if (!selectedCatalogId) {
            return;
        }
        void loadCatalog();
    }, [selectedCatalogId, loadCatalog]);
    const catalogError = catalogActivityError || catalogLoadError;
    const error = (_a = (fileUploadError || catalogError)) === null || _a === void 0 ? void 0 : _a.message;
    const isUploading = isFileUploading || isInitialCatalogStatusLoading;
    const catalogState = (0, react_1.useMemo)(() => {
        const isWaitingForCurrentCatalogActivity = isFileOperationBlocking
            && !hasObservedCatalogActivity.current
            && !(0, lockout_1.isCatalogWorkflowActive)(catalogProgressState);
        if (isUploading || isWaitingForCurrentCatalogActivity) {
            return catalog_1.CatalogProgressState.Uploading;
        }
        if (error) {
            return catalog_1.CatalogProgressState.Error;
        }
        return catalogProgressState;
    }, [isUploading, isFileOperationBlocking, error, catalogProgressState]);
    (0, react_1.useEffect)(() => {
        if (!isFileOperationBlocking) {
            return;
        }
        if ((0, lockout_1.shouldReleaseFileOperationLock)(hasObservedCatalogActivity.current, catalogProgressState, Boolean(catalogActivityError))) {
            hasObservedCatalogActivity.current = false;
            setIsFileOperationBlocking(false);
            return;
        }
        if ((0, lockout_1.isCatalogWorkflowActive)(catalogProgressState)) {
            hasObservedCatalogActivity.current = true;
        }
    }, [isFileOperationBlocking, catalogProgressState, catalogActivityError]);
    const handleSelectCatalogId = (catalogId) => __awaiter(void 0, void 0, void 0, function* () {
        hasObservedCatalogActivity.current = false;
        setIsFileOperationBlocking(false);
        yield clearStore();
        onSelectCatalog({ id: catalogId });
    });
    const handleSelectProject = (project) => __awaiter(void 0, void 0, void 0, function* () {
        hasObservedCatalogActivity.current = false;
        setIsFileOperationBlocking(false);
        yield clearStore();
        onSelectProject({
            id: project.id,
            slug: project.slug,
        });
    });
    const handleCatalogUpdate = (fileToUpload, mode) => __awaiter(void 0, void 0, void 0, function* () {
        setFileUploadError(null);
        setIsInitialCatalogStatusLoading(false);
        setIsFileUploading(true);
        setIsFileOperationBlocking(true);
        hasObservedCatalogActivity.current = false;
        try {
            if (!selectedCatalogId) {
                throw new Error(t({ key: 'GENERAL_ERROR_MESSAGE' }));
            }
            if (mode === upload_file_options_1.UpdateDataModes.Replace) {
                yield replaceCatalog(fileToUpload);
            }
            if (mode === upload_file_options_1.UpdateDataModes.Merge) {
                yield updateCatalog(fileToUpload);
            }
            dispatch((0, store_1.enrichAIRemoveChanges)(selectedCatalogId));
            void loadCatalog();
            setIsUploadDataDialogOpen(false);
            setIsFileUploading(false);
            // Keep the local lock until the activity poll observes the upload and takes over.
        }
        catch (e) {
            setIsFileUploading(false);
            setFileUploadError(e);
            hasObservedCatalogActivity.current = false;
            setIsFileOperationBlocking(false);
        }
    });
    const handleCatalogCreate = (fileToUpload) => __awaiter(void 0, void 0, void 0, function* () {
        setFileUploadError(null);
        setIsInitialCatalogStatusLoading(false);
        setIsFileUploading(true);
        setIsFileOperationBlocking(true);
        hasObservedCatalogActivity.current = false;
        try {
            onSelectStrategyNodePath(null);
            const newCatalogId = yield createNewCatalog(fileToUpload);
            onSelectCatalog({ id: newCatalogId });
            setIsUploadDataDialogOpen(false);
            setIsFileUploading(false);
        }
        catch (e) {
            setIsFileUploading(false);
            setFileUploadError(e);
            hasObservedCatalogActivity.current = false;
            setIsFileOperationBlocking(false);
        }
    });
    const handleEnrichedDataUpdate = (data, columnsOrder, mode) => __awaiter(void 0, void 0, void 0, function* () {
        setFileUploadError(null);
        if (columnsOrder.length < 2) {
            setFileUploadError(new Error(t({ key: 'CSV_PARSE_REQUIRED_COLUMNS_ERROR' })));
        }
        const records = (0, enrich_ai_widgets_utils_1.parseFileData)({
            data,
            columnsOrder,
            mode,
            isMeasuresEnabled,
        });
        if (records.length) {
            dispatch((0, store_1.enrichAIRemoveChanges)(selectedCatalogId));
            try {
                yield addBulkAssertions(records);
                setIsUploadDataDialogOpen(false);
                void updateAggregationStatus(() => {
                    void refetchProductTree();
                    if (selectedTreeNodeId) {
                        void refetchProductList(selectedTreeNodeId);
                    }
                });
            }
            catch (err) {
                setFileUploadError(err);
            }
        }
    });
    const catalogProgressValue = (0, react_1.useMemo)(() => (isUploading ? 0 : catalogProgress), [catalogProgress, isUploading]);
    const isCatalogLoadingNotStarted = catalogState === catalog_1.CatalogProgressState.NotStarted;
    // Local state locks immediately; catalog polling preserves the lock across refreshes and Retool uploads.
    // Re-enrichment is excluded because it uses partial UI and edit lockouts instead of the full-screen loader.
    const shouldShowBlockingLoader = (0, lockout_1.shouldShowFullScreenLockout)({
        isFileOperationBlocking,
        isUploadInProgress,
    });
    const isCompleted = catalogState === catalog_1.CatalogProgressState.Completed;
    const shouldShowContent = (0, lockout_1.shouldShowCatalogContent)(catalogState, shouldShowBlockingLoader);
    const showCatalogLoadingError = catalogError && !isFileUploading;
    return (react_1.default.createElement(enrich_ai_styles_1.StyledPageContainer, { className: "workspace" }, react_1.default.createElement(ui_components_1.PageTitle, { className: 'title', title: t({ key: 'ENRICH_AI_TITLE' }), buttons: react_1.default.createElement(enrich_ai_widgets_page_title_buttons_1.PageTitleButtons, { selectedCatalogId: selectedCatalogId, isCompleted: isCompleted, setIsUploadDataDialogOpen: setIsUploadDataDialogOpen, getCatalogDownloadUrl: getCatalogDownloadUrl, loading: loading, disableCatalogActions: shouldShowBlockingLoader }) }), react_1.default.createElement(enrich_ai_settings_widget_1.EnrichAISettingsWidget, { selectedProjectId: selectedProjectId, selectedCatalogId: selectedCatalogId, onSelectCatalogId: handleSelectCatalogId, onSelectProject: handleSelectProject }), react_1.default.createElement(enrich_ai_styles_1.StyledStrategyPreviewWidget, null, react_1.default.createElement(strategy_preview_1.StrategyPreviewContainer, { isLoading: shouldShowBlockingLoader })), isUploadDataDialogOpen && (react_1.default.createElement(upload_data_dialog_1.UploadDataDialog, { isDisabled: !selectedCatalogId, isFileUploading: isFileUploading || isEnrichedDataUpdating, fileUploadError: (fileUploadError === null || fileUploadError === void 0 ? void 0 : fileUploadError.message) || (updateEnrichedDataError === null || updateEnrichedDataError === void 0 ? void 0 : updateEnrichedDataError.message), onClose: () => setIsUploadDataDialogOpen(false), onCatalogUpdate: handleCatalogUpdate, onCatalogCreate: handleCatalogCreate, onEnrichedDataUpdate: handleEnrichedDataUpdate })), react_1.default.createElement(enrich_ai_styles_1.StyledPreviewProductsWidgetContainer, null, react_1.default.createElement(preview_products_widget_1.PreviewProductsWidget, { showNoDataFallback: isCatalogLoadingNotStarted, catalogLoadingError: showCatalogLoadingError && catalogError.message, showPreviewLoader: !showCatalogLoadingError && shouldShowBlockingLoader, showWidgetContent: shouldShowContent, onReEnrich: loadCatalog, previewLoaderComponent: (react_1.default.createElement(components_1.PreviewSkeleton, { className: "preview-products-skeleton" }, shouldShowBlockingLoader && !showCatalogLoadingError ? (react_1.default.createElement(preview_products_loader_1.PreviewProductsLoader, { progress: catalogProgressValue, error: error, progressState: catalogState })) : null)) }))));
};
exports.EnrichAIWidgetsContainer = EnrichAIWidgetsContainer;
exports.default = exports.EnrichAIWidgetsContainer;
